import b from 'b_';
import { Spin, Text } from 'platform-components';
import { TEXT_MARKUP_TYPE, UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/constants';
import React from 'react';

import { SearchResultBySubject } from '../__result/search__result';
import { LIBRARY_SEARCH_STATE, SearchResult, SearchResults } from '../typings';

import './search__content.scss';

interface Props {
    onResultClick: (res: SearchResult) => void;
    searchState: LIBRARY_SEARCH_STATE | null;
    searchResults: SearchResults;
}

export const LibrarySearchContent = ({ onResultClick, searchState, searchResults }: Props) => {
    switch (searchState) {
        case LIBRARY_SEARCH_STATE.EMPTY:
            return (
                <div className={b('library', 'search-content', { empty: true })}>
                    <Text
                        id="library.search.empty"
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                        typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}
                    />
                </div>
            );
        case LIBRARY_SEARCH_STATE.LOADED:
            return <SearchResultBySubject onResultClick={onResultClick} searchResults={searchResults} />;
        case LIBRARY_SEARCH_STATE.LOADING:
            return (
                <>
                    <SearchResultBySubject onResultClick={onResultClick} searchResults={searchResults} />
                    <Spin center />
                </>
            );
        case LIBRARY_SEARCH_STATE.NOT_FOUND:
            return (
                <div className={b('library', 'search-content', { 'not-found': true })}>
                    <Text
                        id="library.search.notFound"
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                        typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}
                    />
                </div>
            );
        default:
            return null;
    }
};
